/*
 * Author: Duncan Levings
 * 
 * Copyright (c) 2020 DuncanLevings
 */

export default {
    SLAYER: 0,
    BOSS: 1,
    RAID: 2
}